import React, { useState } from 'react';
import ContactForm from './ContactForm';
import BookDemoForm from './BookDemoForm';
import Icon from '../../../components/AppIcon';

const ContactHeroSection = () => {
  const [activeTab, setActiveTab] = useState('contact'); // 'contact' or 'demo'

  return (
    <section
      style={{
        minHeight: '100vh',
        width: '100%',
        position: 'relative',
        backgroundColor: '#242423',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
      }}
      className="px-4 md:px-6 lg:px-8 py-24"
    >
      {/* Background Image Layer - Very Subtle */}
      <div
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundImage: 'url(/assets/images/Contacts-1770329078710.png)',
          backgroundSize: 'cover',
          backgroundPosition: 'center top',
          backgroundRepeat: 'no-repeat',
          opacity: 0.12,
          zIndex: 0,
        }}
      />

      {/* Gradient Fade Overlay - Aggressive Fade */}
      <div
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background:
            'linear-gradient(to bottom, transparent 0%, rgba(36, 36, 35, 0.4) 30%, rgba(36, 36, 35, 0.8) 60%, #242423 85%)',
          zIndex: 1,
        }}
      />

      {/* Content - Hero Text AND Contact Form */}
      <div
        style={{
          position: 'relative',
          zIndex: 2,
        }}
        className="max-w-2xl mx-auto w-full"
      >
        {/* Hero Title and Description */}
        <div className="text-center mb-12">
          <h1 className="text-4xl md:text-5xl font-bold mb-4" style={{ color: '#E8EDDF' }}>
            Get in Touch
          </h1>
          <p className="text-lg md:text-xl" style={{ color: '#9CA3AF' }}>
            Have questions or want to see Sleeve in action? We're here to help.
          </p>
        </div>

        {/* Tab Toggle */}
        <div className="flex gap-2 mb-8 p-1 bg-muted rounded-lg">
          <button
            onClick={() => setActiveTab('contact')}
            className={`flex-1 py-3 px-4 rounded-md font-medium transition-all duration-200 ${
              activeTab === 'contact' ? 'bg-background text-foreground shadow-sm' : 'text-muted-foreground hover:text-foreground'
            }`}
          >
            <div className="flex items-center justify-center gap-2">
              <Icon name="Mail" size={18} />
              <span>Contact</span>
            </div>
          </button>
          <button
            onClick={() => setActiveTab('demo')}
            className={`flex-1 py-3 px-4 rounded-md font-medium transition-all duration-200 ${
              activeTab === 'demo' ? 'bg-background text-foreground shadow-sm' : 'text-muted-foreground hover:text-foreground'
            }`}
          >
            <div className="flex items-center justify-center gap-2">
              <Icon name="Calendar" size={18} />
              <span>Book a Demo</span>
            </div>
          </button>
        </div>

        {/* Form Content */}
        <div className="bg-card border border-border rounded-lg p-8 shadow-sm">
          {activeTab === 'contact' ? <ContactForm /> : <BookDemoForm />}
        </div>
      </div>
    </section>
  );
};

export default ContactHeroSection;